export default __webpack_public_path__ + "static/media/about1bg.ffa5c10d.png";